"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var useIsFirstRender_1 = __importDefault(require("../useIsFirstRender"));
function useDidUpdate(callback, deps) {
  var isFirstRender = (0, useIsFirstRender_1["default"])();
  // eslint-disable-next-line consistent-return
  (0, react_1.useEffect)(function () {
    if (!isFirstRender) {
      return callback();
    }
  }, deps);
}
exports["default"] = useDidUpdate;